// Adapted from GitHub (https://github.com/DanSnow/vue-recaptcha/issues/215#issuecomment-459306315)
export function cleanupRecaptcha () {
  Array.from(document.getElementsByTagName('iframe')).forEach(iframe => {
    if (!iframe.title.startsWith('recaptcha challenge')) return;
    const el = iframe.parentElement.parentElement;
    if (el.tagName !== 'DIV' || el.style.visibility !== 'hidden') return;
    el.remove();
  });
}
